import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from './session.service';
import {
  AnaliseRegrasRequest,
  AnaliseRegrasResponse,
  SelecionarRegraRequest,
  DownloadQTCRequest,
} from '../models/regra.model';

@Injectable({
  providedIn: 'root',
})
export class RegraService {
  private apiUrl = environment.URL_API;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  /**
   * Realiza análise de regras para aposentadoria
   * GET com query params (body será ignorado pelo Angular HttpClient)
   */
  analisarRegras(request: AnaliseRegrasRequest): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });

    const body = {
      matricula: request.matricula,
      idOrgao: request.idOrgao,
      dataAposentadoria: request.dataAposentadoria,
    };

    return this.http.post<AnaliseRegrasResponse>(`${this.apiUrl}/regras/analise`, body, {
      headers,
    });
  }

  /**
   * Seleciona uma regra específica para aposentadoria
   * POST /regras/selecionada
   */
  selecionarRegra(request: SelecionarRegraRequest): Observable<AnaliseRegrasResponse> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
      'Content-Type': 'application/json',
    });

    const body = {
      matricula: request.matricula,
      idOrgao: request.idOrgao,
      dataAposentadoria: request.dataAposentadoria,
      idRegraSelecionada: request.idRegraSelecionada,
    };

    return this.http.post<AnaliseRegrasResponse>(`${this.apiUrl}/regras/selecionada`, body, {
      headers,
    });
  }

  /**
   * Download do relatório QTC (Quadro de Tempo de Contribuição)
   * POST /pdf/quadro-tempo-contribuicao
   */
  downloadQTC(request: DownloadQTCRequest): Observable<Blob> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
      'Content-Type': 'application/json',
    });

    const body = {
      matricula: request.matricula,
      orgaoId: request.orgaoId,
      idRegra: request.idRegra,
      dataAposentadoria: request.dataAposentadoria,
    };

    return this.http.post(`${this.apiUrl}/pdf/quadro-tempo-contribuicao`, body, {
      headers,
      responseType: 'blob',
    });
  }

  /**
   * Download do relatório QRB (Quadro de Regras do Benefício)
   * POST /pdf/quadro-regras-beneficio
   */
  downloadQRB(request: DownloadQTCRequest): Observable<Blob> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
      'Content-Type': 'application/json',
    });

    const body = {
      matricula: request.matricula,
      orgaoId: request.orgaoId,
      idRegra: request.idRegra,
      dataAposentadoria: request.dataAposentadoria,
    };

    return this.http.post(`${this.apiUrl}/pdf/quadro-regras-beneficio`, body, {
      headers,
      responseType: 'blob',
    });
  }
}
